import { getVariablesForElement } from '@bpmn-io/extract-process-variables/zeebe';
import { useEffect, useState } from '@bpmn-io/properties-panel/preact/hooks';
import { useService } from 'bpmn-js-properties-panel';

{ /* Required to break up imports, see https://github.com/babel/babel/issues/15156 */ }

function useServiceIfAvailable(service, fallback) {
  const resolved = useService(service, false);

  if (!resolved) {
    return fallback;
  }

  return resolved;
}

export function withVariableContext(Component) {
  return props => {
    const { bpmnElement, element } = props;

    const bo = (bpmnElement || element).businessObject;

    const [ variables, setVariables ] = useState([]);
    const eventBus = useService('eventBus');

    const variableResolver = useServiceIfAvailable('variableResolver', { getVariablesForElement });

    useEffect(() => {
      const extractVariables = async () => {

        const variables = await variableResolver.getVariablesForElement(bo);

        setVariables(variables.map(variable => {
          return {
            ...variable,
            info: variable.info ||
                  (variable.origin && ('Written in ' + variable.origin.map(origin => origin.name || origin.id).join(', ')))
          };
        }));
      };

      // The callback must return undefined, so the event propagation is not canceled.
      // Cf. https://github.com/camunda/camunda-modeler/issues/3392
      const callback = () => {
        extractVariables();
      };

      eventBus.on('commandStack.changed', callback);
      callback();

      return () => {
        eventBus.off('commandStack.changed', callback);
      };
    }, [ bo ]);

    return <Component { ...props } variables={ variables }></Component>;
  };
}